import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField
} from "@mui/material";
import api from "../api";

export default function ScreensList() {
  const [screens, setScreens] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", location: "" });

  const fetchScreens = async () => {
    const res = await api.get("/api.php?action=screens_list");
    setScreens(res.data.data);
  };

  const handleSave = async () => {
    await api.post("/screens", form);
    setOpen(false);
    fetchScreens();
  };

  const handleDelete = async (id) => {
    await api.delete(`/screens/${id}`);
    fetchScreens();
  };

  useEffect(() => {
    fetchScreens();
  }, []);

  return (
    <div>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Add Screen
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Location</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {screens.map((screen) => (
            <TableRow key={screen.id}>
              <TableCell>{screen.name}</TableCell>
              <TableCell>{screen.location}</TableCell>
              <TableCell>
                <Button onClick={() => handleDelete(screen.id)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add Screen</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <TextField
            label="Location"
            fullWidth
            onChange={(e) => setForm({ ...form, location: e.target.value })}
          />
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
